<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent != null && localService.languageContent.barcode != undefined">
  <div class="row" style="margin-top:50px;">
    <div class="col-md-4">
      &nbsp;
    </div>
    <div class="col-md-4">
      <div class="banner">
        <div>
          <input autocomplete="off" style="width:calc(100% - 35px)" id="{{elementIds.qr_code_input}}" type="text" [(ngModel)]="qrCode" [ngClass]="qrCode != '' ? 'en' : ''" placeholder="{{localService.languageContent.barcode.search}}" title="{{localService.languageContent.barcode.search}}" (keyup)="onKeyUp()" (input)="onInput(true)" />
          <app-qr-scanner (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
        </div>
        <div style="text-align:center;color:orangered" *ngIf="message != ''">
          {{message}}
        </div>
        <div>
          <app-qrcode-generator [value]="localService.selected.user" [categoryCode]="categoryCode" [countryCode]="localService.selected.countryCode" [title]="localService.languageContent.barcode.my_barcode"></app-qrcode-generator>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      &nbsp;
    </div>
  </div>
</div>
<span style="display:none;">
  <input type="button" class="force_click_after_load" (click)="onInitiate()" />
</span>
